import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { Heart, Users, TrendingUp, Award } from 'lucide-react';
import { ICompanyDetails } from '../../../redux/company/types';

interface ICultureTab {
    companyDetails?: ICompanyDetails;
}

const CultureTab: React.FC<ICultureTab> = ({ companyDetails }) => {
    const { themeStyle } = useThemeContext();

    const coreValues = [
        { icon: Heart, color: '#EF4444', value: 'Creativity First' },
        { icon: Users, color: '#3B82F6', value: 'Collaborative Spirit' },
        { icon: TrendingUp, color: '#10B981', value: 'Continuous Growth' },
        { icon: Award, color: '#8B5CF6', value: 'Excellence in Craft' },
    ];

    const perks = [
        'Health, dental, and vision insurance',
        'Flexible PTO policy',
        'Remote work options',
        'Professional development budget',
        'Creative software licenses',
        'Team retreats and events',
        'Catered lunches',
        '401(k) with company match',
    ];

    return (
        <Card
            sx={{
                backgroundColor: theme[themeStyle].prisma_dark,
                border: `1px solid ${theme[themeStyle].tag_white_light}`,
                borderRadius: 2,
            }}>
            <CardContent sx={{ p: 3 }}>
                <Typography
                    variant="h6"
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.BOLD_HEADER,
                        mb: 3,
                    }}>
                    Company Culture & Values
                </Typography>

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme[themeStyle].tag_white,
                                fontFamily: FONT_ENUM.BOLD_HEADER,
                                mb: 2,
                            }}>
                            Core Values
                        </Typography>
                        <Box sx={{ spaceY: 2 }}>
                            {coreValues.map((value, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 2,
                                        mb: 2,
                                    }}>
                                    <value.icon size={20} color={value.color} />
                                    <Typography
                                        sx={{
                                            color: theme[themeStyle].tag_white,
                                            fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                        }}>
                                        {value.value}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h6"
                            sx={{
                                color: theme[themeStyle].tag_white,
                                fontFamily: FONT_ENUM.BOLD_HEADER,
                                mb: 2,
                            }}>
                            Perks & Benefits
                        </Typography>
                        <Box sx={{ spaceY: 1 }}>
                            {perks.map((perk, index) => (
                                <Typography
                                    key={index}
                                    sx={{
                                        color: theme[themeStyle].tag_white,
                                        fontFamily: FONT_ENUM.MEDIUM_TEXT,
                                        fontSize: '0.875rem',
                                    }}>
                                    • {perk}
                                </Typography>
                            ))}
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export { CultureTab };
